interface FaqPublishedAtProps {
  contentPublishedAt?: string | null
  contentUpdatedAt?: string | null
}

function toValidDate(dateString?: string | null): Date | null {
  if (!dateString || dateString === 'null') {
    return null
  }
  const parsed = new Date(dateString)
  if (Number.isNaN(parsed.getTime())) {
    return null
  }
  return parsed
}

function formatDate(date: Date): string {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}/${month}/${day}`
}

/**
 * FAQ公開日・更新日表示コンポーネント
 * FAQ管理画面 > 詳細設定（CSS変数 / customCssVariables）で調整可能:
 * --display-faq-published-at-desktop
 * --display-faq-published-at-mobile
 * --padding-faq-published-at-desktop
 * --padding-faq-published-at-mobile
 * --margin-top-faq-published-at-desktop
 * --margin-top-faq-published-at-mobile
 * --fs-faq-published-at-desktop
 * --fs-faq-published-at-mobile
 * --fw-faq-published-at-label
 * --fw-faq-published-at-value
 * --color-faq-published-at-text
 */
export function FaqPublishedAt({ contentPublishedAt, contentUpdatedAt }: FaqPublishedAtProps) {
  const publishedDate = toValidDate(contentPublishedAt)
  const updatedDate = toValidDate(contentUpdatedAt)
  const currentDate = updatedDate ?? publishedDate
  const currentType = updatedDate ? 'updated' : 'published'

  if (!currentDate) {
    return null
  }

  return (
    <div className={`faq-published-at faq-published-at--${currentType}`}>
      <span className={`faq-published-at__${currentType}`}>
        <span className="faq-published-at__label">
          {currentType === 'updated' ? '更新日:' : '公開日:'}
        </span>
        <time className="faq-published-at__value" dateTime={currentDate.toISOString()}>
          {formatDate(currentDate)}
        </time>
      </span>
    </div>
  )
}
